export type RdThemePreset = 'dark' | 'light'

export const RD_THEME_STORAGE_KEY = 'rd_theme_preset'

export const normalizeRdThemePreset = (value: string | null | undefined): RdThemePreset => {
  return value === 'light' ? 'light' : 'dark'
}

export const applyRdThemeDocumentState = (preset: RdThemePreset) => {
  document.documentElement.dataset.rdTheme = preset
  document.documentElement.classList.toggle('rd-theme-light', preset === 'light')
  document.documentElement.classList.toggle('rd-theme-dark', preset === 'dark')
  document.documentElement.style.colorScheme = preset
}